import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from '@global/constants'

export const buttonIcon = css`
  margin-right: 4px;
  color: ${colors.gray.medium};
`

export const ButtonLabel = styled.span`
  position: relative;
  top: 1px;
`
